import { render, staticRenderFns } from "./OrgGoals.vue?vue&type=template&id=385318bc&"
import script from "./OrgGoals.vue?vue&type=script&lang=js&"
export * from "./OrgGoals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports